import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_18608652 from 'nuxt_plugin_plugin_18608652' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_876217a8 from 'nuxt_plugin_sentryserver_876217a8' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_569582a4 from 'nuxt_plugin_sentryclient_569582a4' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_3b0779ba from 'nuxt_plugin_plugin_3b0779ba' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_image_ae19cd3a from 'nuxt_plugin_image_ae19cd3a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_portalvue_714050eb from 'nuxt_plugin_portalvue_714050eb' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_342fec10 from 'nuxt_plugin_cookieuniversalnuxt_342fec10' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_0f50d4f4 from 'nuxt_plugin_nuxtsvgsprite_0f50d4f4' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_pluginutils_5b59aed3 from 'nuxt_plugin_pluginutils_5b59aed3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_bcac5944 from 'nuxt_plugin_pluginrouting_bcac5944' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_e42df65e from 'nuxt_plugin_pluginmain_e42df65e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtgooglemaps_d17ef122 from 'nuxt_plugin_nuxtgooglemaps_d17ef122' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_setup_231e1d09 from 'nuxt_plugin_setup_231e1d09' // Source: ../plugins/setup (mode: 'all')
import nuxt_plugin_jsonld_320ccf54 from 'nuxt_plugin_jsonld_320ccf54' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_alerts_224a118b from 'nuxt_plugin_alerts_224a118b' // Source: ../plugins/alerts (mode: 'all')
import nuxt_plugin_localeRouting_4b1c8798 from 'nuxt_plugin_localeRouting_4b1c8798' // Source: ../plugins/localeRouting (mode: 'all')
import nuxt_plugin_gtm_2cfa83cb from 'nuxt_plugin_gtm_2cfa83cb' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_magiczoom_8312da2a from 'nuxt_plugin_magiczoom_8312da2a' // Source: ../plugins/magiczoom.js (mode: 'client')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_globalListener_9923d72a from 'nuxt_plugin_globalListener_9923d72a' // Source: ../plugins/globalListener (mode: 'client')
import nuxt_plugin_meta_72167b4c from 'nuxt_plugin_meta_72167b4c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Mazaya","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Welcome toMazaya in Egypt. ✓ Buy now online & Discover a wide range of home appliances of brands Toshiba، Sharp، Tornado، Sony، Seiko and More."},{"name":"google-site-verification","content":"gynGpMKMdJtshB6KcqVWvF7E7KksgD_B-1V9O3H2rUo"},{"name":"google-site-verification","content":"zP-cvuGxQT_n_VJSYtRAy2nDeUaoSlxBk5Ov_1xxsGw"},{"name":"google-site-verification","content":"gtd7i1ioHOBDX1GdzIYVMxw05brU78XgI_lTRnUMR7w"},{"name":"apple-itunes-app","content":"app-id=1562432316"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffurla\u002Ffavicon-furla.ico"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2048-2732.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2732-2048.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1668-2388.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2388-1668.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1536-2048.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2048-1536.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1668-2224.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2224-1668.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1620-2160.png","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2160-1620.png","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1284-2778.png","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2778-1284.png","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1170-2532.png","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2532-1170.png","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1125-2436.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2436-1125.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1242-2688.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2688-1242.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-828-1792.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1792-828.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1242-2208.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-2208-1242.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-750-1334.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1334-750.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-640-1136.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"\u002Ficons\u002Fapple-splash-1136-640.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffurla.hypernode.io"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffurla.hypernode.io"}],"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_18608652 === 'function') {
    await nuxt_plugin_plugin_18608652(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_876217a8 === 'function') {
    await nuxt_plugin_sentryserver_876217a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_569582a4 === 'function') {
    await nuxt_plugin_sentryclient_569582a4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3b0779ba === 'function') {
    await nuxt_plugin_plugin_3b0779ba(app.context, inject)
  }

  if (typeof nuxt_plugin_image_ae19cd3a === 'function') {
    await nuxt_plugin_image_ae19cd3a(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_714050eb === 'function') {
    await nuxt_plugin_portalvue_714050eb(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_342fec10 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_342fec10(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_0f50d4f4 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_0f50d4f4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5b59aed3 === 'function') {
    await nuxt_plugin_pluginutils_5b59aed3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_bcac5944 === 'function') {
    await nuxt_plugin_pluginrouting_bcac5944(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_e42df65e === 'function') {
    await nuxt_plugin_pluginmain_e42df65e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_d17ef122 === 'function') {
    await nuxt_plugin_nuxtgooglemaps_d17ef122(app.context, inject)
  }

  if (typeof nuxt_plugin_setup_231e1d09 === 'function') {
    await nuxt_plugin_setup_231e1d09(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_320ccf54 === 'function') {
    await nuxt_plugin_jsonld_320ccf54(app.context, inject)
  }

  if (typeof nuxt_plugin_alerts_224a118b === 'function') {
    await nuxt_plugin_alerts_224a118b(app.context, inject)
  }

  if (typeof nuxt_plugin_localeRouting_4b1c8798 === 'function') {
    await nuxt_plugin_localeRouting_4b1c8798(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_2cfa83cb === 'function') {
    await nuxt_plugin_gtm_2cfa83cb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_magiczoom_8312da2a === 'function') {
    await nuxt_plugin_magiczoom_8312da2a(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalListener_9923d72a === 'function') {
    await nuxt_plugin_globalListener_9923d72a(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_72167b4c === 'function') {
    await nuxt_plugin_meta_72167b4c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
